import { WebGivingViewModel } from './webgiving-generated';
import { WebGivingMain } from './main/webgiving-main';
import { getWebGivingDataService } from './webgiving-data-service';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import moment from 'moment';
import { configure } from 'mobx';
import { WebGivingMainViewModel } from './main/webgiving-main-view-model';
import { GoogleAnalyticsWrapper } from './infrastructure/google-analytics-wrapper';
import { AjaxUtils } from '../Shared/utils/ajax-utils';
import './utils/hover-on-touch-fix';
import 'moment/locale/es';
import { scrollToTopOnRefresh } from '../Shared/utils/scroll-to-top';
import { initTranslation } from './translation';
import { evidently, mockOutEvidently } from './evidently';
moment.locale('en'); // Sets default locale

configure({ enforceActions: true });
let disableValidation = false;

async function initApp(model: WebGivingViewModel) {
	GoogleAnalyticsWrapper.initialize('WebGiving');
	const { MerchantInfo, UIConfiguration, EvidentlyConfig } = model;

	const { configure } = await evidently();
	configure({
		cognito: {
			identityPoolId: EvidentlyConfig.CognitoIdentityPoolId,
			region: EvidentlyConfig.Region,
			role: EvidentlyConfig.CognitoRole,
		},
		evidently: {
			endpoint: EvidentlyConfig.Endpoint,
			region: EvidentlyConfig.Region,
			project: EvidentlyConfig.Project,
		},
	});

	if (MerchantInfo.IsEntitledToLanguageSelector) {
		// Force english translation when hiding i18n toggle
		const defaultToEnglish = UIConfiguration.HideI18n;
		initTranslation(Boolean(defaultToEnglish));
	}

	const vm = new WebGivingMainViewModel(model, disableValidation);
	ReactDOM.render(React.createElement(WebGivingMain, { vm }), document.getElementById('react-container'));
	scrollToTopOnRefresh();

	// temporary to have the service testable from Chrome DevTools
	if (DEBUG) {
		(window as any)['dataService'] = getWebGivingDataService();
		(window as any)['vm'] = vm;
	}
}

export function init(model: string) {
	initApp(parseModelJSON(model));
}

export function initInDemoMode(m: string) {
	disableValidation = true;
	mockOutEvidently();

	const model = parseModelJSON(m);

	window.pushpay.webgiving_demo.init(model);
	initApp(model);
}

function parseModelJSON(model: string): WebGivingViewModel {
	return JSON.parse(model, AjaxUtils.reviveDate);
}
